export default Component => Component.displayName || Component.name || 'UnknownComponent';
